<template>
	<v-container fluid>
		<v-row v-if="loading">
			<v-col col="12">
				
			</v-col>
		</v-row>
		<div v-else-if="isSubcontractor">
					
			<ProjectHeaderInfo
				v-if="project"
				:readOnlyMode="readOnlyMode"
				:contract="contract"
				:project="project"
				:show-details-header="showDetailsHeader"
				:can-edit-info="false"
				:can-assign-responsible="false"
				:can-edit-client="false"
				:company-contract-prefixes="companyContractPrefixes"
				:zones="zones"
				:users-list="$store.state.users.usersList"
				:project-line-associations="projectLineAssociations"
				:user-info="userInfo"
				:user-responsible="userResponsible"
				:contract-value="contractValue"
				:project-type-subtitle="projectTypeSubtitle"
				:project-type-title="projectTypeTitle"
				:required-rule="requiredRule"
				:can-edit-contract-value="false"
				:hide-contract-status="true"
				@change-contract-prefix="changeContractPrefix"
				@edit-project-data="editProjectData"
				@go-to="handleGoTo"
				@change-ipt-zone="changeIptZone"
				@change-project-type="changeProjectType"
				@change-project-destiny="changeProjectDestiny"
				@change-responsible="changeResponsible"
				@edit-user="editUser"
			/>
			<CostSubcontractPaymentsConfigTable
				:project="project"
				:ufValue="ufValue"
				:currency="currency"
				:costsTable="costs_table"
				:focusedTab="tab"
				:fromSubcontractor="true"
				@update:SubcontractStageTitle="handleStageTitleChange"
				@update:subcontractInfo="handleSubcontractInfoChange"/>

		</div>
		<div v-else>
			<v-speed-dial
				v-model="actionButton"
				:bottom="true"
				:right="true"
				style="position: fixed;"
			>
				<template v-slot:activator>
					<v-btn
						v-model="actionButton"
						color="#FF120B"
						dark
						fab
						small
					>
						<v-icon v-if="actionButton">
							mdi-close
						</v-icon>
						<v-icon v-else>
							mdi-plus
						</v-icon>
					</v-btn>
				</template>
				<div class="text-right align-self-end">
					<v-btn
						dark
						small
						color="#959595"
						@click="addProject"
					>
						<v-icon>mdi-plus</v-icon>
						<p class="mb-0 caption">Agregar Proyecto</p>
					</v-btn>
					<v-btn
						dark
						small
						color="#959595"
						@click="addReception"
					>
						<v-icon>mdi-plus</v-icon>
						<p class="mb-0 caption">Incluir Recepción</p>
					</v-btn>
					<v-btn
						dark
						small
						color="#959595"
						@click="addStage"
					>
						<v-icon>mdi-plus</v-icon>
						<p class="mb-0 caption">Agregar Etapa</p>
					</v-btn>
					<v-btn
						dark
						small
						color="#959595"
						@click="addSpecialty"
					>
						<v-icon>mdi-plus</v-icon>
						<p class="mb-0 caption">Agregar Proyecto / Especialidad</p>
					</v-btn>
				</div>
			</v-speed-dial>
					
			<ProjectHeaderInfo
				v-if="project"
				:contract="contract"
				:project="project"
				:show-details-header="showDetailsHeader"
				:can-edit-info="canEditInfo"
				:hide-contract-status="true"
				:can-assign-responsible="$checkPermissions(['assign_responsible_user'])"
				:can-edit-client="project.responsible_id == userInfo.id && canEditInfo"
				:company-contract-prefixes="companyContractPrefixes"
				:zones="zones"
				:users-list="$store.state.users.usersList"
				:project-line-associations="projectLineAssociations"
				:user-info="userInfo"
				:user-responsible="userResponsible"
				:contract-value="contractValue"
				:project-type-subtitle="projectTypeSubtitle"
				:project-type-title="projectTypeTitle"
				:required-rule="requiredRule"
				:can-edit-contract-value="false"
				:toContractDetail="toContractDetail"
				@change-contract-prefix="changeContractPrefix"
				@edit-project-data="editProjectData"
				@go-to="handleGoTo"
				@change-ipt-zone="changeIptZone"
				@change-project-type="changeProjectType"
				@change-project-destiny="changeProjectDestiny"
				@change-responsible="changeResponsible"
				@edit-user="editUser"
			/>
			<v-card v-if="project" class="budget-modal-card mb-4">
				<v-card-text class="py-2">
					<div class="d-flex align-center justify-space-between mt-2" :class="{ 'flex-column': $vuetify.breakpoint.width < 750 }">
						<div class="d-flex align-start justify-space-between flex-1" style="gap: 5px;" :style="{ width: $vuetify.breakpoint.width < 750 ? '100%' : 'auto' }">
							<div class="d-flex align-center" :class="{ 'flex-column': $vuetify.breakpoint.width < 1000 }">
								<ProjectTypeSelectorMenuSelect 
										:isDisabled="!canEditInfo"
										:projectType="project?.info?.project_type"
										:onClick="(project_type) => { changeProjectType(project_type.id) }"/>
								<div class="d-flex align-center mt-1" style="width: 100%" v-if="canShowReceptionSection">
									<v-checkbox class="my-0 py-0" :input-value="hasReception" color="#959595" hide-details dense @click="onChangeReceptionValue"></v-checkbox>
									<p class="mb-0 caption font-weight-bold">Incluye Recepción</p>
								</div>
							</div>
							<v-select
								v-model="selectedUfValue"
								:items="ufValues"
								:menu-props="{ top: true, offsetY: true }"
								label="Seleccione Valor UF"
								item-text="uf_value"
								item-value="id"
								class="custom-height-search custom-height-calendar custom-select-uf align-center mb-0 mr-1 w-100"
								:class="{ 'mt-2': $vuetify.breakpoint.width > 1000, 'blocked-content-cost-table': tab == 3 }"
								outlined
								dense
								required
								return-object
								style="width: 180px;max-width: 180px;"
							>
								<template v-slot:prepend-item>
									<div class="px-3 pt-1" style="max-width: 220px;">
										<p class="mb-0" style="font-size: 10px;">Considera que esto cambiará el valor de la uf utilizada solo en la tabla activa.</p>
										<p class="mt-1 mb-0 font-weight-bold" style="font-size: 10px;">Tabla Activa: {{ workingTableContractCode }}</p>
									</div>
									<v-divider class="my-1"></v-divider>
								</template>
								<template v-slot:item="data">
									<v-list-item-content>
										<v-list-item-title>
											<div class="d-flex align-center justify-space-between" style="width: 180px">
												<p class="mb-0">{{data.item.date | toDateFormat}}</p>
												<p class="mb-0 font-weight-bold">${{data.item.uf_value | toThousandFilter(2)}}</p>
											</div>
										</v-list-item-title>
									</v-list-item-content>
								</template>
								<template v-slot:selection="data">
									<div class="d-flex align-center justify-space-between" style="width: 180px;margin-bottom: 10px;">
										<p class="mb-0 caption">{{data.item.date | toDateFormat}}</p>
										<span>-</span>
										<p class="mb-0 font-weight-bold caption">${{data.item.uf_value | toThousandFilter(2)}}</p>
									</div>
								</template>
							</v-select>
						</div>
						<div class="d-flex justify-end align-center mt-1"
							:class="{ 'flex-wrap': $vuetify.breakpoint.width < 1000 }" style="gap: 5px;"
							:style="{
								width: $vuetify.breakpoint.width < 750 ? '100%' : 'auto'
							}"
							>
							<div class="d-flex align-center flex-1" :class="{ 'flex-wrap': $vuetify.breakpoint.width < 1000 }" style="gap: 5px;">
								<div
									:style="{
										opacity: !canEditInfo ? 0.5 : 1,
										pointerEvents: !canEditInfo ? 'none' : 'auto'
									}">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												depressed
												color="#524D4D"
												small
												dark
												@click="editProjectPlanning"
												v-bind="attrs"
												v-on="on"
											>
												<v-icon small>mdi-chart-gantt</v-icon>
												<p class="mb-0 ml-2 caption" v-if="$vuetify.breakpoint.width > 750">Programación</p>
											</v-btn>
										</template>
										<span>Configurar la Programación del Proyecto</span>
									</v-tooltip>
								</div>
								<v-btn
									depressed
									color="#FF120B"
									small
									dark
									class="flex-1"
									@click="startSaveCostTable(true)"
								>
									<v-icon small>mdi-check</v-icon>
									<p class="mb-0 ml-2 caption">Guardar</p>
								</v-btn>
							</div>
							<v-divider vertical class="mx-2" v-if="$vuetify.breakpoint.width >= 1000"></v-divider>
							<div class="d-flex align-center flex-1" style="gap: 5px;">

								<!-- v-if="projectContractClosed" -->
								<UserChatSelectorMenu
									:users="chatUsers"
									:projectSubcontractors="subcontractContractorUser"
									:projectLineChatRoom="costs_table.project_line_chat_room"
									:currentUserId="userInfo.id"
									:projectLineId="project?.project_line_info?.project_line_id"
									:projectLineNumber="project?.project_line_info?.project_line?.number"
									:projectName="project?.name"
									tooltipText="Chatear con un Usuario Involucrado"
									@user-room-updated="getCosts"
								/>
								<AdditionalRequirementsMenu
									:contract="contract"
									:project="project"
									:design="2"
								/>
								<ProjectLineDocumentsMenu :project_line_id="project?.project_line_info?.project_line_id" />
								<CostBreakdownSettings
									:costsTable="working_cost_table"
									:changeTaxSelection="onChangeTaxSelection"/>
							</div>
						</div>
					</div>
				</v-card-text>
			</v-card>
			<v-tabs
				v-model="tab"
				class="custom-color-tabs"
				color="white"
				grow
				height="40">
				<v-tab>Tabla General de Costos</v-tab>
				<v-tab v-show="costs_table.project_tables && costs_table.project_tables.length">
					<div>
						<p class="mb-0">Anexos Tabla de Costos</p>
						<p class="mb-0" style="font-size: 10px;">(Adicionales)</p>
					</div>
				</v-tab>
				<v-tab>Tabla Resumen / Programación Pagos</v-tab>
				<v-tab>Externos / Subcontratos</v-tab>
				<v-tab v-show="selectedCompany && selectedCompany.company?.config?.supervision_allowed">Patrocinio</v-tab>
				<v-tab>Costo Total Proyecto</v-tab>
			</v-tabs>
			<v-tabs-items v-model="tab" class="tab-item-custom" style="width: 100%; flex-grow: 1;min-height: 300px;">
				<v-tab-item eager>
					<!-- <div class="d-flex align-center justify-space-between px-4 py-2"
						:class="showRelatedTables ? 'mb-2' : ''">
						<p class="mb-0 font-weight-bold">Tablas de Costo Relacionadas</p>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									text
									color="#524D4D"
									x-small
									v-bind="attrs"
									v-on="on"
									@click="toggleShowRelatedTables()"
								>
									<v-icon dark small>{{showRelatedTables ? 'mdi-chevron-up' : 'mdi-chevron-down'}}</v-icon>
									<p class="mb-0 ml-2 caption">{{showRelatedTables ? 'Ocultar' : 'Ver'}} Tablas Relacionadas</p>
								</v-btn>
							</template>
							<span>Ver Otras Tablas</span>
						</v-tooltip>
					</div> -->
					<!-- <div v-show="showRelatedTables" class="px-4 blocked-content-cost-table">
						<div v-for="(project_table, index) in costs_table.project_tables" :key="'project_tables_main-' + index" class="my-2">
							<SecondaryTableCost
								:selectedUfValue="selectedUfValue"
								:costs-table="project_table"
								:project="project"
								:colors="colors"
								:colorVars="colorVars"
								:uf-value="ufValue"
								:currency="currency"
								:col-widths="colWidths"
								:can-show-reception-section="canShowReceptionSection"
								:cost_categories_config="cost_categories_config"
							/>
						</div>
					</div> -->
					<div>
						<GeneralTableCost
							:costs-table="costs_table"
							:contract="contract"
							:project="project"
							:colors="colors"
							:colorVars="colorVars"
							:ufValueBase="ufValue"
							:selectedUfValue="selectedUfValue"
							:currency="currency"
							:col-widths="colWidths"
							:can-show-reception-section="canShowReceptionSection"
							:cost_categories_config="cost_categories_config"
							:addStage="addStage"
							:addProject="addProject"
							:removeProject="removeProject"
							:onChangeSecondaryCostProject="onChangeSecondaryCostProject"
							:onChangeSecondaryCostProjectItem="onChangeSecondaryCostProjectItem"
							:updateStage="updateStage"
							:addReception="addReception"
							:removeReception="removeReception"
							:updateReception="updateReception"
							:addSpecialty="addSpecialty"
							:updateSpecialty="updateSpecialty"
							:updateSurfaceItems="updateSurfaceItems"
							:updateCostItems="updateCostItems"
							@open-summary-modal="$store.commit('costbreakdown/setCostBreakdownSummaryTablesModal', true)"
							@update:costsTable="updateMainCostsTable"
						/>
					</div>
					<!-- <TableCostTotals
						v-show="costs_table.project_tables?.length"
						:costsTable="costs_table"
						:colors="colors"
						:colWidths="colWidths"/> -->
				</v-tab-item>
				<v-tab-item eager v-show="costs_table.project_tables && costs_table.project_tables.length">
					<div class="px-4">
						<div v-for="(project_table, index) in sortedProjectTables" :key="'project_tables_main-' + index" class="my-2">
							<SecondaryTableCost
								:isLastItem="index === costs_table.project_tables.length -1"
								:selectedUfValue="selectedUfValue"
								:costs-table="project_table"
								:parent-costs-table="costs_table"
								:project="project"
								:colors="colors"
								:colorVars="colorVars"
								:ufValueBase="ufValue"
								:currency="currency"
								:col-widths="colWidths"
								:can-show-reception-section="canShowReceptionSection"
								:cost_categories_config="cost_categories_config"
								@update:secondaryTableCost="onUpdateSecondaryTableCost"
							/>
						</div>
					</div>
				</v-tab-item>
				<v-tab-item>
					<CostSummaryTable
						:project="project"
						:ufValue="ufValue"
						:currency="currency"
						@saveCostsTable="startSaveCostTable"
						/>
					<!-- <div v-for="(project_table, index) in costs_table.project_tables" :key="'project_tables_summary-' + index" class="my-2">
						<CostSummaryTable
							:costsTable="project_table"
							:project="project"
							:ufValue="ufValue"
							:currency="currency"
							:showHeader="false"/>
					</div> -->

					<CostPaymentsConfigTable
						:costsTable="costs_table"
						:project="project"
						:project_tables="costs_table.project_tables"
						@update:costsPayments="handleCostPaymentChange"
						@saveCostsTable="startSaveCostTable"/>
					<!-- <div v-for="(project_table, index) in costs_table.project_tables" :key="'project_tables_payments-' + index" class="my-2">
						<CostPaymentsConfigTable
							:costsTable="{...project_table, ...{payments: costs_table.payments}}"
							:project="project"
							@update:costsPayments="handleCostPaymentChange"
							@saveCostsTable="startSaveCostTable"
							:showHeader="false"/>
					</div> -->
					<!-- <CostPaymentsTable :costsTable="costs_table" :project="project" /> -->
				</v-tab-item>
				<v-tab-item>
					<CostSubcontractPaymentsConfigTable
						v-if="tab === 3"
						:project="project"
						:ufValue="ufValue"
						:currency="currency"
						:costsTable="costs_table"
						:focusedTab="tab"
						@update:SubcontractStageTitle="handleStageTitleChange"
						@update:subcontractInfo="handleSubcontractInfoChange"/>
				</v-tab-item>
				<v-tab-item v-show="selectedCompany && selectedCompany.company?.config?.supervision_allowed">
					<CostSupervisionTable :costsTable="costs_table" :project="project" :ufValue="ufValue" :currency="currency" @update:costsPayments="handleCostPaymentChange"/>
				</v-tab-item>
				<v-tab-item>
					<CostPaymentStatusTable
						:costsTable="costs_table"
						:project="project"
						:ufValue="ufValue"
						:currency="currency"
						:project_tables="costs_table.project_tables"/>
				</v-tab-item>
			</v-tabs-items>
			<CostBreakdownSummaryTablesModal
				v-if="$store.state.costbreakdown.costBreakdownSummaryTablesModal"
				:costs-table="costs_table"
				:contract="contract"
				:project="project"
			/>
			<CostBreakdownMainTableModal
				v-if="$store.state.costbreakdown.costBreakdownMainTableModal"
				:costs-table="costs_table"
				:contract="contract"
				:project="project"
				:colors="colors"
				:colorVars="colorVars"
				:uf-value="ufValue"
				:selectedUfValue="selectedUfValue"
				:currency="currency"
				:col-widths="colWidths"
				:can-show-reception-section="canShowReceptionSection"
				:cost_categories_config="cost_categories_config"
				:addStage="addStage"
				:addProject="addProject"
				:removeProject="removeProject"
				:onChangeSecondaryCostProject="onChangeSecondaryCostProject"
				:onChangeSecondaryCostProjectItem="onChangeSecondaryCostProjectItem"
				:updateStage="updateStage"
				:addReception="addReception"
				:removeReception="removeReception"
				:updateReception="updateReception"
				:addSpecialty="addSpecialty"
				:updateSpecialty="updateSpecialty"
				:updateSurfaceItems="updateSurfaceItems"
				:updateCostItems="updateCostItems"
			/>
		</div>
	</v-container>
</template>

<script>
import _debounce from 'lodash/debounce'
import _throttle from 'lodash/throttle'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import CostBreakdownSettings from '@/components/Views/Projects/CostBreakdownSettings'
import GeneralTableCost from '@/components/Views/Projects/TableCostParts/GeneralTableCost.vue'
import SecondaryTableCost from '@/components/Views/Projects/TableCostParts/SecondaryTableCost.vue'
import CostSummaryTable from '@/components/Views/Projects/CostSummary/CostSummaryTable'
import CostSupervisionTable from '@/components/Views/Projects/CostSummary/CostSupervisionTable'
// import CostPaymentsTable from '@/components/Views/Projects/CostSummary/CostPaymentsTable'
import CostPaymentsConfigTable from '@/components/Views/Projects/CostSummary/CostPaymentsConfigTable'
import CostSubcontractPaymentsConfigTable from '@/components/Views/Projects/CostSummary/CostSubcontractPaymentsConfigTable'
import CostPaymentStatusTable from '@/components/Views/Projects/CostSummary/CostPaymentStatusTable'
import CostBreakdownSummaryTablesModal from '@/components/Modals/CostBreakdown/CostBreakdownSummaryTablesModal'
import CostBreakdownMainTableModal from '@/components/Modals/CostBreakdown/CostBreakdownMainTableModal'
import ProjectTypeSelectorMenuSelect from '@/components/Helpers/Components/ProjectTypeSelectorMenuSelect'
import UserChatSelectorMenu from '@/components/Helpers/Components/UserChatSelectorMenu'
import AdditionalRequirementsMenu from '@/components/Views/Projects/Requirements/AdditionalRequirementsMenu'
import ProjectLineDocumentsMenu from '@/components/Views/Projects/Parts/ProjectLineDocumentsMenu'

// import SubcategorySummaryTable from '@/components/Views/Projects/Parts/SubcategorySummaryTable'
import {getProjectCostDetail, createCostTemplate, deleteCostTemplate, saveProjectCostDetail} from '@/helpers/api/costs'
import {updateProjectInfo} from '@/helpers/api/projects'
import ProjectHeaderInfo from '@/components/Views/Projects/Parts/ProjectHeaderInfo'
import { updateContract } from '@/helpers/api/contracts'
import {setResponsible as setResponsiblePreProject} from '@/helpers/api/preprojects'
import {setResponsible as setResponsibleProject} from '@/helpers/api/projects'
import {editCrmResponsible} from '@/helpers/api/crm'
import { addContractAddendum } from '@/helpers/api/contracts'
import { contractStatuses } from '@/components/Helpers/Constants/contract.js'
import { deepDiff } from '@/helpers/tablecostHelpers.js'

export default {
	components: {
		CostBreakdownSettings,
		GeneralTableCost,
		SecondaryTableCost,
		CostSummaryTable,
		CostPaymentsConfigTable,
		CostSubcontractPaymentsConfigTable,
		CostPaymentStatusTable,
		CostBreakdownSummaryTablesModal,
		CostBreakdownMainTableModal,
		ProjectHeaderInfo,
		ProjectTypeSelectorMenuSelect,
		UserChatSelectorMenu,
		CostSupervisionTable,
		AdditionalRequirementsMenu,
		ProjectLineDocumentsMenu
	},
	data() {
		return {
			contractStatuses,
			tab: 0,
			colorPicker: false,
			costTablePrimaryColor: '#263238',
			costTableSecondaryColor: '#546e7a',
			colWidths: ['30%','10%','10%','15%','12%','15%','8%'],
			showDetailsHeader: true,
			actionButton: false,
			project: null,
			contract: null,
			showColors: false,
      colorPickerVisible: false,
      activeColorKey: 'costTablePrimaryColor',
      colorVars: [
        {value: 'costTablePrimaryColor', text: 'Título y Totales Generales'},
        // {value: 'costTableThirdColor', text: 'Secciones Principales'},
        {value: 'costTableSecondaryColor', text: 'Encabezados Sección'},
        {value: 'costTableFourthColor', text: 'Subtotales'},
        {value: 'costTableSectionsMain', text: 'Proyecto Directo'},
        // {value: 'costTableSectionsProjects', text: 'Proyectos Adicionales'},
        {value: 'costTableSectionsReception', text: 'Recepción Final'},
        {value: 'costTableSectionsStages', text: 'Posibles Etapas'},
        {value: 'costTableSectionsSpecialties', text: 'Proyectos / Especialidades'},
      ],
			cost_categories_config: null,
			costs_table_check: null,
			isReloading: false,
			selectedUfValue: this.dayUfValue,
			showDetails: [],
			menuTemplates: false,
			menuNewTemplate: false,
			showAddNewTemplate: false,
			templateName: null,
			validform: true,
			editingCategory: null,
			editingSubcategory: null,
			cost_categories: [],
			showDetail: [],
			loading: true,
			loadingBudget: false,
			requiredRule: [
				v => !!v || 'Campo requerido'
			],
			limit: 10,
			start: 0,
			showRelatedTables: false,
			savingCostsTableInternal: false,
			pendingCostsTableInternal: null,
			firstDelayTimerInternal: null,
			forceUpdateAfterSave: false,
			accumulatedGetCostUpdated: false
		};
	},
	computed: {
		currency(){
			return this.working_cost_table?.currency == 1 ? 'uf' : 'clp'
		},
		isSubcontractor(){
			return this.$store.state.user.companyPermissions?.subcontractor === true
		},
		readOnlyMode(){
			return this.isSubcontractor
		},
		sortedProjectTables() {
			if (!this.costs_table.project_tables || !this.costs_table.project_tables.length) return null;
			const workingId = this.working_cost_table.id;
			return [...this.costs_table.project_tables].sort((a, b) => {
					if (a.id === workingId) return -1;
					if (b.id === workingId) return 1;
					return 0;
			});
		},
		workingTableContractCode() {
			const contract = this.working_cost_table.contract
			if(contract?.parent_contract){
				let append = ''
				if(contract.addendum_to_contract_id){
					append = ` - ANX Nº ${contract.addendum_index}`
				}
				else if(contract.subcontract_to_contract_id){
					append = ` - SUB Nº ${contract.subcontract_index}`
				}
				return `${contract.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${contract.info?.prefix?.prefix} ${contract.parent_contract?.info?.contract_prefix_index} ${append}`
			}
			return `${contract.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${contract.info?.prefix?.prefix} ${contract.info?.contract_prefix_index}`
		},
		working_cost_table(){
			if(!this.costs_table) return null
			if(this.costs_table.project_tables?.length){
				const foundIndex = this.costs_table.project_tables
																					.findIndex(ptable => {
																						return ptable.contract?.last_status?.status != contractStatuses.FIRMADO_AMBAS_PARTES
																					})
				if(foundIndex != -1){
					return this.costs_table.project_tables[foundIndex]
				}
			}
			return this.costs_table
		},
		costs_table: {
			get() {
				return this.$store.state.projects.costsTable
			},
			set(value) {
				this.$store.commit('projects/setCostsTable', value)
			}
		},
		costTableBlocked(){
			return this.projectContractClosed
		},
		projectContractClosed(){
			return this.contract?.last_status?.status == contractStatuses.FIRMADO_AMBAS_PARTES
		},
		isTableForAddendum(){
			return !!this.contract?.addendum_to_contract_id
		},
    contractType(){
			if(this.contract?.addendum_to_contract_id){
				return 'Anexo de Contrato'
			}
			return 'Contrato'
		},
		openAddendum(){
			const addendum = this.contract.addendums?.find(addendum => addendum.last_status?.status < contractStatuses.FIRMADO_CONTRAPARTE)
			const addendum_cost_table = this.costs_table.project_tables?.find(ptable => ptable.contract?.addendum_to_contract_id == this.contract.id)
			return addendum && addendum_cost_table
		},
		hasAddendumWithoutCostTable(){
			const addendum = this.contract.addendums?.find(addendum => addendum.last_status?.status < contractStatuses.FIRMADO_CONTRAPARTE)
			const addendum_cost_table = this.costs_table.project_tables?.find(ptable => ptable.contract?.addendum_to_contract_id == this.contract.id)
			return addendum && !addendum_cost_table
		},
		hasAddendumWithCostTable(){
			return !!this.openAddendum
		},
		noAddendum(){
			return !this.contract.addendums?.length
		},
		userInfo(){
			return this.$store.state.user.userInfo
		},
		canEditInfo(){
			// Puede editar sólo si tiene permiso y si no hay un contrato firmado en la línea de proyectos
			return !this.project.pl_signed_contract && this.isUserResponsible
		},
		isUserResponsible(){
			return this.$store.state.user?.userInfo?.id == this.project?.responsible_id
		},
		projectTypeTitle() {
			return this.costs_table?.contract?.info?.project_type?.name || this.project?.info?.project_type?.name || 'Tipo de Proyecto No Definido';
		},
    projectTypeSubtitle() {
      const parentName = this.costs_table?.contract?.info?.project_type?.parent?.name || this.project?.info?.project_type?.parent?.name || '';
      const categoryName = this.costs_table?.contract?.info?.project_type?.category?.name || this.project?.info?.project_type?.category?.name || '';
      
      if (parentName && categoryName) {
        return `${categoryName} | ${parentName}`;
      }
      return parentName || categoryName || '';
    },
		companyContractPrefixes(){
			return this.$store.state.budget.companiesBudgetPrefixes.filter((prefix) => {
				return prefix.type == 'contract'
			})
		},
		zones(){
			return this.$store.state.projects.zoneIpt
		},
		contractValue(){
			return this.contract?.contract_info?.contract_value
		},
		userResponsible(){
			if(this.project?.responsible?.profile){
				let fullName = this.project?.responsible?.profile?.name
				if(this.project?.responsible?.profile?.lastname){
					fullName = fullName + ' ' + this.project?.responsible?.profile?.lastname + ' ' + this.project?.responsible?.profile?.second_lastname
				}
				return fullName
			}
			return null
		},
		canShowReceptionSection(){
			return this.project?.info?.project_type?.type != 2 && this.project?.info?.project_type?.category?.type == 1
		},
		hasReception() {
			console.log('[DEBUG] hasReception computed property:', this.costs_table.reception);
			return !!this.costs_table.reception
		},
		currentColor: {
			get() {
				return this.colors[this.activeColorKey]
			},
			set(value) {
				this.$store.commit('costbreakdown/setCostTableColorMap', {
					[this.activeColorKey]: value
				});
			}
		},
		colors(){
			const colors = {
				costTablePrimaryColor: '#263238',
				costTableSecondaryColor: '#546e7a',
				costTableThirdColor: '#37474f',
				costTableFourthColor: '#90a4ae',
				costTableSectionsMain: '#37474f',
				costTableSectionsProjects: '#37474f',
				costTableSectionsReception: '#37474f',
				costTableSectionsStages: '#37474f',
				costTableSectionsSpecialties: '#37474f',
				summaryTableColor: 'green',
				paymentStatusTableColor: '#2196F3',
				paymentsTableColor: '#009688',
				paymentConfigTableColor: '#fb8c00',
				footerSummaryTables: '#37474f',
				...this.$store.state.costbreakdown.costTableColorMap
			}
			return colors
		},
		projectLineAssociations(){
			return this.project?.associations
			// if(this.project.associations?.associations){
			// 	const project_associations = this.project.associations
			// 	return project_associations.associations.map((association) => {
			// 		return {...association, ...{type_name: this.getAssociationType(association.morphable_type)}}
			// 	})
			// }
			// return []
		},
		totalProjectCostSummary() {
			const total = {
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0,
				total_cost_uf: 0,
				total_cost_clp: 0
			};

			const sources = [
				this.detailTotalCostSummary,
				this.stageTotalCostSummary,
				this.specialtiesTotalCostSummary,
				this.projectsTotalCostSummary,
				this.receptionTotalCostSummary
			];

			for (const result of sources) {
				total.qty += result.qty || 0;
				total.unit_cost_uf += result.unit_cost_uf || 0;
				total.unit_cost_clp += result.unit_cost_clp || 0;
				total.total_cost_uf += result.total_cost_uf || 0;
				total.total_cost_clp += result.total_cost_clp || 0;
			}

			return total;
		},
		detailTotalCostSummary() {
			const totals = {
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0,
				total_cost_uf: 0,
				total_cost_clp: 0
			};

			const parse = (n) => parseFloat(n) || 0;
			
			if (this.costs_table.surfaces && Array.isArray(this.costs_table.surfaces.items)) {
				for (const item of this.costs_table.surfaces.items) {
					const qty = parse(item.qty);
					const uf = parse(item.unit_cost_uf);
					const clp = parse(item.unit_cost_clp);

					totals.qty += qty;
					totals.unit_cost_uf += uf;
					totals.unit_cost_clp += clp;
					totals.total_cost_uf += uf * qty;
					totals.total_cost_clp += clp * qty;
				}
			}

			if (Array.isArray(this.costs_table.items)) {
				for (const item of this.costs_table.items) {
					if (Array.isArray(item.subitems) && item.subitems.length) {
						for (const sub of item.subitems) {
							const qty = parse(sub.qty);
							const uf = parse(sub.unit_cost_uf);
							const clp = parse(sub.unit_cost_clp);

							totals.qty += qty;
							totals.unit_cost_uf += uf;
							totals.unit_cost_clp += clp;
							totals.total_cost_uf += uf * qty;
							totals.total_cost_clp += clp * qty;
						}
					} else {
						const qty = parse(item.qty);
						const uf = parse(item.unit_cost_uf);
						const clp = parse(item.unit_cost_clp);

						totals.qty += qty;
						totals.unit_cost_uf += uf;
						totals.unit_cost_clp += clp;
						totals.total_cost_uf += uf * qty;
						totals.total_cost_clp += clp * qty;
					}
				}
			}

			return totals;
		},
		costAllProjectsTotalSummary() {
			const totals = {
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0,
				total_cost_uf: 0,
				total_cost_clp: 0
			};

			if (Array.isArray(this.costs_table.projects)) {
				this.costs_table.projects.forEach((project, index) => {
					const projectTotals = this.costProjectDetailTotalCostSummary(index);

					totals.qty += projectTotals.qty;
					totals.unit_cost_uf += projectTotals.unit_cost_uf;
					totals.unit_cost_clp += projectTotals.unit_cost_clp;
					totals.total_cost_uf += Math.round(projectTotals.total_cost_uf);
					totals.total_cost_clp += Math.round(projectTotals.total_cost_clp);
				});
			}

			return totals;
		},
		stageTotalCostSummary() {
			const totals = {
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0,
				total_cost_uf: 0,
				total_cost_clp: 0
			};

			const parse = (n) => parseFloat(n) || 0;

			if (Array.isArray(this.costs_table.stages)) {
				for (const stage of this.costs_table.stages) {
					if (!Array.isArray(stage.items)) continue;

					for (const item of stage.items) {
						if (Array.isArray(item.subitems) && item.subitems.length > 0) {
							for (const sub of item.subitems) {
								const qty = parse(sub.qty);
								const uf = parse(sub.unit_cost_uf);
								const clp = parse(sub.unit_cost_clp);

								totals.qty += qty;
								totals.unit_cost_uf += uf;
								totals.unit_cost_clp += clp;
								totals.total_cost_uf += uf * qty;
								totals.total_cost_clp += clp * qty;
							}
						} else {
							const qty = parse(item.qty);
							const uf = parse(item.unit_cost_uf);
							const clp = parse(item.unit_cost_clp);

							totals.qty += qty;
							totals.unit_cost_uf += uf;
							totals.unit_cost_clp += clp;
							totals.total_cost_uf += uf * qty;
							totals.total_cost_clp += clp * qty;
						}
					}
				}
			}

			return totals;
		},
		specialtiesTotalCostSummary() {
			const totals = {
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0,
				total_cost_uf: 0,
				total_cost_clp: 0
			};

			const parse = (n) => parseFloat(n) || 0;

			if (Array.isArray(this.costs_table.specialties)) {
				for (const specialty of this.costs_table.specialties) {
					const hasItems = Array.isArray(specialty.items) && specialty.items.length > 0;

					if (hasItems) {
						for (const item of specialty.items) {
							const hasSubitems = Array.isArray(item.subitems) && item.subitems.length > 0;

							if (hasSubitems) {
								for (const sub of item.subitems) {
									const qty = parse(sub.qty);
									const uf = parse(sub.unit_cost_uf);
									const clp = parse(sub.unit_cost_clp);

									totals.qty += qty;
									totals.unit_cost_uf += uf;
									totals.unit_cost_clp += clp;
									totals.total_cost_uf += uf * qty;
									totals.total_cost_clp += clp * qty;
								}
							} else {
								const qty = parse(item.qty);
								const uf = parse(item.unit_cost_uf);
								const clp = parse(item.unit_cost_clp);

								totals.qty += qty;
								totals.unit_cost_uf += uf;
								totals.unit_cost_clp += clp;
								totals.total_cost_uf += uf * qty;
								totals.total_cost_clp += clp * qty;
							}
						}
					} else {
						const qty = parse(specialty.qty);
						const uf = parse(specialty.unit_cost_uf);
						const clp = parse(specialty.unit_cost_clp);

						totals.qty += qty;
						totals.unit_cost_uf += uf;
						totals.unit_cost_clp += clp;
						totals.total_cost_uf += uf * qty;
						totals.total_cost_clp += clp * qty;
					}
				}
			}

			return totals;
		},
		projectsTotalCostSummary() {
			const totals = {
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0,
				total_cost_uf: 0,
				total_cost_clp: 0
			};

			const parse = (n) => parseFloat(n) || 0;

			if (Array.isArray(this.costs_table.projects)) {
				for (const project of this.costs_table.projects) {
					const hasItems = Array.isArray(project.items) && project.items.length > 0;

					if (hasItems) {
						for (const item of project.items) {
							const hasSubitems = Array.isArray(item.subitems) && item.subitems.length > 0;

							if (hasSubitems) {
								for (const sub of item.subitems) {
									const qty = parse(sub.qty);
									const uf = parse(sub.unit_cost_uf);
									const clp = parse(sub.unit_cost_clp);

									totals.qty += qty;
									totals.unit_cost_uf += uf;
									totals.unit_cost_clp += clp;
									totals.total_cost_uf += uf * qty;
									totals.total_cost_clp += clp * qty;
								}
							} else {
								const qty = parse(item.qty);
								const uf = parse(item.unit_cost_uf);
								const clp = parse(item.unit_cost_clp);

								totals.qty += qty;
								totals.unit_cost_uf += uf;
								totals.unit_cost_clp += clp;
								totals.total_cost_uf += uf * qty;
								totals.total_cost_clp += clp * qty;
							}
						}
					} else {
						const qty = parse(project.qty);
						const uf = parse(project.unit_cost_uf);
						const clp = parse(project.unit_cost_clp);

						totals.qty += qty;
						totals.unit_cost_uf += uf;
						totals.unit_cost_clp += clp;
						totals.total_cost_uf += uf * qty;
						totals.total_cost_clp += clp * qty;
					}
				}
			}

			return totals;
		},
		stagesTotalCost(){
			let total = 0;

			if (Array.isArray(this.costs_table.stages)) {
				for (const stage of this.costs_table.stages) {
					if (Array.isArray(stage.items)) {
						for (const item of stage.items) {
							total += (item.qty || 0) * (item.unit_cost_uf || 0);

							if (Array.isArray(item.subitems)) {
								for (const subitem of item.subitems) {
									total += (subitem.qty || 0) * (subitem.unit_cost_uf || 0);
								}
							}
						}
					}
				}
			}

			return total;
		},
		receptionTotalCostSummary() {
			const totals = {
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0,
				total_cost_uf: 0,
				total_cost_clp: 0
			};

			const parse = (n) => parseFloat(n) || 0;
			const round2 = (n) => Math.round(n * 100) / 100;

			const processItem = (item) => {
				const qty = parse(item.qty);
				const uf = parse(item.unit_cost_uf);
				const clp = parse(item.unit_cost_clp);

				totals.qty += qty;
				totals.unit_cost_uf += uf;
				totals.unit_cost_clp += clp;
				totals.total_cost_uf += uf * qty;
				totals.total_cost_clp += clp * qty;
			};

			if (this.costs_table.reception) {
				const reception = this.costs_table.reception;
				if (Array.isArray(reception.items)) {
					for (const item of reception.items) {
						processItem(item);

						if (Array.isArray(item.subitems)) {
							for (const sub of item.subitems) {
								processItem(sub);
							}
						}
					}
				}
				if (Array.isArray(reception.subitems) && reception.subitems.length) {
					for (const sub of reception.subitems) {
						processItem(sub);
					}
				}

				if (
					(!Array.isArray(reception.items) || !reception.items.length) &&
					(!Array.isArray(reception.subitems) || !reception.subitems.length)
				) {
					processItem(reception);
				}
			}

			return {
				qty: round2(totals.qty),
				unit_cost_uf: round2(totals.unit_cost_uf),
				unit_cost_clp: round2(totals.unit_cost_clp),
				total_cost_uf: round2(totals.total_cost_uf),
				total_cost_clp: round2(totals.total_cost_clp),
			};
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		dayUfValue(){
			const valueUf = this.ufValues
			let todayData = null
			if(valueUf && valueUf.length > 0){
				const today = new Date().toISOString().split('T')[0]; // formato 'YYYY-MM-DD'
				todayData = valueUf.find(item => item.date === today);
			}
			return todayData
		},
		ufValue(){
			return this.selectedUfValue?.uf_value || 40000
		},
		ufValues(){
			return this.$store.state.general.posteriorDaysUf
		},
		companyCostSpecialties(){
			return this.$store.state.costbreakdown.companiesCostCategories
		},
		companySpecialties(){
			return this.$store.state.costbreakdown.companiesSpecialties
		},
		costProjects(){
			return this.$store.state.costbreakdown.companiesBaseProjects
		},
		costSpecialties(){
			return this.$store.state.costbreakdown.companiesCostSpecialties
		},
		costGeneralSubCategories(){
			return this.$store.state.costbreakdown.companiesCostGeneralSubCategories
		},
		subcontractorList(){
			return this.$store.state.users.usersList.filter(user => {
				return user.company_rol?.capabilities?.subcontractor === true
			})
		},
		companyUserList(){
			return this.$store.state.users.usersList.filter(user => {
				return !user.company_rol?.capabilities?.subcontractor
			})
		},
		chatUsers(){
			let chat_users = []
			if(this.project?.client){
				chat_users.push({
					...this.project.client,
					userType: 'client'
				})
			}
			if(this.companyUserList?.length){
				chat_users = chat_users.concat(this.companyUserList.map(user => {
					return {
						...user,
						userType: 'company_user'
					}
				}))
			}
			if(this.subcontractContractorUser?.length){
				chat_users = chat_users.concat(this.subcontractContractorUser.map(user => {
					return {
						...user,
						userType: 'project_subcontractor'
					}
				}))
			}
			// if(this.subcontractorList?.length){
			// 	chat_users = chat_users.concat(this.subcontractorList.map(user => {
			// 		return {
			// 			...user,
			// 			userType: 'subcontractor'
			// 		}
			// 	}))
			// }
			return chat_users
		},
		subcontractContractorUser(){
			let subcontractors = []
			if(this.costs_table?.subcontracts_info?.cost_table?.contractor && this.costs_table.subcontracts_info?.cost_table?.subcontract){
				subcontractors.push(this.costs_table.subcontracts_info.cost_table.contractor)
			}
			if(this.costs_table?.subcontracts_info?.reception?.contractor && this.costs_table.subcontracts_info?.reception?.subcontract){
				subcontractors.push(this.costs_table.subcontracts_info.reception.contractor)
			}
			if(this.costs_table?.subcontracts_info?.stages?.length){
				subcontractors = subcontractors.concat(this.costs_table.subcontracts_info.stages.map(s => s.subcontract ? s.contractor : null).filter(c => c))
			}
			if(this.costs_table?.subcontracts_info?.specialties?.length){
				subcontractors = subcontractors.concat(this.costs_table.subcontracts_info.specialties.map(s => s.subcontract ? s.contractor : null).filter(c => c))
			}
			
			// Filtrar null y eliminar duplicados por ID
			return subcontractors.filter(contractor => {
				return contractor !== null && contractor !== undefined && contractor.id
			}).reduce((unique, contractor) => {
				// Evitar duplicados basados en ID
				if (!unique.find(c => c.id === contractor.id)) {
					unique.push(contractor)
				}
				return unique
			}, [])
		}
	},
	watch: {
		costs_table: {
			deep: true,
			handler(newValue){
				if(this.isReloading) return
				if(!this.costs_table_check){
					this.costs_table_check = JSON.parse(JSON.stringify(newValue))
					return
				}
				const diff = deepDiff(this.costs_table_check, newValue)
				console.log('[DEBUG] diff', diff)
				if(diff && diff.length > 0){
					const get_updated_value = this.shouldGetCostsAfterSave(diff)
					// console.log('[DEBUG] get_updated_value', get_updated_value)
					this.startSaveCostTable(get_updated_value)
				}
				this.costs_table_check = JSON.parse(JSON.stringify(newValue))
			}
		},
		selectedCompany(newValue){
			if(newValue){
				this.getCosts()
				this.$store.dispatch('users/getUserFromCompany')
				this.$store.dispatch('costbreakdown/getCompanyCostItems')
				this.$store.dispatch('costbreakdown/getCompanyCostTemplates')
				this.$store.dispatch('costbreakdown/getCompanyBaseProjects')
				this.$store.dispatch('costbreakdown/getCompanyCostSpecialties')
				this.$store.dispatch('projects/getAllZoneIpts')
			}
		},
		tab(newValue){
			let hash = null
			if(newValue === 0){
				hash = '#general'
			}
			else if(newValue === 1){
				hash = '#addendums'
			}
			else if(newValue === 2){
				hash = '#summary'
			}
			else if(newValue === 3){
				hash = '#external'
			}
			else if(newValue === 4){
				hash = '#supervision'
			}
			else if(newValue === 5){
				hash = '#total'
			}
			// window.history.replaceState(null, null, hash)
			hash && this.$router.replace({ hash })
		},
		ufValues(newValue){
			if(newValue && newValue.length > 0){
				this.setUfSelectedValue()
			}
		},
		working_cost_table(newValue, oldValue){
			if(newValue?.id !== oldValue?.id){
				if (this.ufValues && this.ufValues.length > 0) {
					this.setUfSelectedValue()
				}
			}
		},
		selectedUfValue(newValue, oldValue){
			if (newValue === oldValue) return

			const workingId = this.working_cost_table?.id
			if (!workingId) return

			if (this.costs_table?.id === workingId) {
				this.$set(this.costs_table, 'uf_value_id', newValue?.id)
				// this.startSaveCostTable(true)
			}

			const table = this.costs_table.project_tables?.find(
				t => t.id === workingId
			)

			if (table) {
				this.$set(table, 'uf_value_id', newValue?.id)
				// this.startSaveCostTable(true)
			}

			eventBus.$emit('updatedUfSelection')
		},
		// currency: {
		// 	handler(newValue, oldValue) {
		// 		if (oldValue !== undefined && newValue !== oldValue) {
		// 			this.startSaveCostTable(true);
		// 		}
		// 	},
		// 	immediate: true
		// },
		'$route.query.contract': {
			handler(val) {
				console.log('Route query "contract" changed:', val);
				this.getCosts()
			}
		},
		'$route.hash': function(newHash) {
			if (newHash === '#addendums' && this.tab !== 1) {
				this.tab = 1;
			} else if (newHash === '#summary' && this.tab !== 2) {
				this.tab = 2;
			} else if (newHash === '#external' && this.tab !== 3) {
				this.tab = 3;
			} else if (newHash === '#supervision' && this.tab !== 0) {
				this.tab = 4;
			} else if (newHash === '#total' && this.tab !== 0) {
				this.tab = 5;
			} else if (newHash === '#general' && this.tab !== 0) {
				this.tab = 0;
			}
		},
		'costs_table.project_tables': {
			handler(newValue) {
				// Si el usuario está en la pestaña de anexos y se eliminan los anexos, volver a la pestaña general
				if (this.tab === 1 && (!newValue || !newValue.length)) {
					this.tab = 0;
				}
			},
			deep: true
		}
	},
	mounted(){
		if(this.selectedCompany){
			this.$store.dispatch('users/getUserFromCompany')
			this.$store.dispatch('costbreakdown/getCompanyCostItems')
			this.$store.dispatch('costbreakdown/getCompanyCostTemplates')
			this.$store.dispatch('costbreakdown/getCompanyBaseProjects')
			this.$store.dispatch('costbreakdown/getCompanyCostSpecialties')
			this.$store.dispatch('projects/getAllZoneIpts')
			this.getCosts()
		}
		if(!this.costs_table?.uf_value_id){
			this.selectedUfValue = this.dayUfValue
		}
		const currentHash = this.$route.hash
		if(currentHash){
			if(currentHash === '#addendums'){
				this.tab = 1
			}
			else if(currentHash === '#summary'){
				this.tab = 2
			}
			else if(currentHash === '#external'){
				this.tab = 3
			}
			else if(currentHash === '#supervision'){
				this.tab = 4
			}
			else if(currentHash === '#total'){
				this.tab = 5
			}
			else{
				this.tab = 0
			}
		}
		eventBus.$on('reloadInformation', this.onReloadInformation)
		eventBus.$on('addReceptionToProjectCost', this.onAddReceptionToProjectCost)

		// setInterval(() => {
		// 	if(JSON.stringify(this.costs_table_check) !== JSON.stringify(this.costs_table)){
		// 		console.log('Changes detected in costs_table, saving...')
		// 		this.costs_table_check && this.startSaveCostTable()
		// 		this.costs_table_check = JSON.parse(JSON.stringify(this.costs_table))
		// 	}
		// }, 10000)
	},
	beforeDestroy(){
		eventBus.$off('reloadInformation', this.onReloadInformation)
		eventBus.$off('addReceptionToProjectCost', this.onAddReceptionToProjectCost)
	},
	methods: {
		// shouldGetCostsAfterSave(changes){
		// 	// const base = d.type == 'added' || typeof d.newValue === 'object' &&  d.newValue !== null && d.newValue.id === null
		// 	// const reception = d.path == 'reception' || (/project_tables\[\d+\]\.reception/.test(d.path))
			
		// 	return changes.some(d => {
		// 		return (
		// 			d.type == 'added' ||
		// 			d.path == 'reception' ||
		// 			(/project_tables\[\d+\]\.reception/.test(d.path))) && 
		// 			typeof d.newValue === 'object' && 
		// 			d.newValue !== null &&
		// 			d.newValue.id === null
		// 	})
		// },
		shouldGetCostsAfterSave(changes) {
			const subcontractPatterns = [
				/^subcontract$/,
				/^reception\.subcontract$/,
				/^specialties\[\d+\]\.subcontract$/,
				/^stages\[\d+\]\.subcontract$/,
				/^project_tables\[\d+\]\.subcontract$/,
				/^project_tables\[\d+\]\.reception\.subcontract$/,
				/^project_tables\[\d+\]\.specialties\[\d+\]\.subcontract$/,
				/^project_tables\[\d+\]\.stages\[\d+\]\.subcontract$/,
			]

			return changes.some(d => {
				// console.log('[DEBUG] Evaluating change for cost update:', d)
				const isNewObject =
					typeof d.newValue === 'object' &&
					d.newValue !== null &&
					d.newValue.id === null

				const isAddedSupervision = d.type === 'added' && isNewObject
																		&& d.path.includes('supervision')
				// console.log('[DEBUG] isAddedSupervision:', isAddedSupervision)
				// Para paths hijo directo de subcontracts_info (especialidades, stages, etc)
				const isAddedSubcontractChild = 
					(
						isNewObject ||
						d.type === 'added' ||
						(d.type === 'type_changed' && d.newType === 'object')
					) && (
					/^subcontracts_info\.specialties\[\d+\]$/.test(d.path) ||
					/^subcontracts_info\.stages\[\d+\]$/.test(d.path) ||
					/^subcontracts_info\.cost_table$/.test(d.path) ||
					/^subcontracts_info\.reception$/.test(d.path) ||
					/^subcontracts_info\.project_tables\[\d+\]$/.test(d.path)
				)

				const isSubcontractCase =
						d.oldValue === false &&
						d.newValue === true &&
						subcontractPatterns.some(regex => regex.test(d.path))

				const isReceptionCase =
					isNewObject &&
					(
						d.path === 'reception' ||
						/^project_tables\[\d+\]\.reception$/.test(d.path)
					)

				const isStageCase =
					isNewObject &&
					/^(?:stages(?:\[\d+\])?|project_tables\[\d+\]\.stages(?:\[\d+\])?)$/.test(d.path)

				const isSpecialtyCase =
					isNewObject &&
					/^(?:specialties(?:\[\d+\])?|project_tables\[\d+\]\.specialties(?:\[\d+\])?)$/.test(d.path)

				const isItemCase =
					isNewObject &&
					/^(?:items(?:\[\d+\])?|reception(?:\.items(?:\[\d+\])?)?|(?:stages|specialties|projects)\[\d+\]\.items(?:\[\d+\])?|project_tables\[\d+\]\.(?:items(?:\[\d+\])?|reception(?:\.items(?:\[\d+\])?)|(?:stages|specialties|projects)\[\d+\]\.items(?:\[\d+\])?))$/.test(d.path)

				const isSurfaceCase =
					/^(?:surfaces(?:\.items(?:\[\d+\])?)?|project_tables\[\d+\]\.surfaces(?:\.items(?:\[\d+\])?)?)$/.test(d.path) &&
					(
						isNewObject ||
						d.type === 'added' ||
						(d.type === 'type_changed' && d.newType === 'object')
					)

				const isSupervisionPayment =
					isNewObject &&
					/(^|\.)(supervision_payments)(\[\d+\])?$/.test(d.path) &&
					!/project_tables/.test(d.path)

				return isAddedSupervision || isSubcontractCase || isReceptionCase || isAddedSubcontractChild || isStageCase || isSpecialtyCase || isItemCase || isSupervisionPayment || isSurfaceCase
			})
		},
		updateMainCostsTable(costs_table){
			const surfaces = {...this.costs_table.surfaces, items: costs_table.surfaces}
			const reception = costs_table.reception ? {...this.costs_table.reception, ...costs_table.reception} : this.costs_table.reception
			const stages = [...costs_table.stages]
			const specialties = [...costs_table.specialties]
			const items = [...costs_table.items]
			this.costs_table = {
				...this.costs_table,
				surfaces,
				reception,
				stages,
				specialties,
				items
			}
			// this.startSaveCostTable(true)
		},
		onUpdateSecondaryTableCost(change_data){
			const {costs_table} = change_data
			const secondaryTableIndex = this.costs_table.project_tables.findIndex(ptable => ptable.id == costs_table.id)
			if(secondaryTableIndex != -1){
				this.$set(this.costs_table.project_tables, secondaryTableIndex, costs_table)
				// force_save && this.startSaveCostTable(get_cost_table_updated)
			}
		},
		toggleShowRelatedTables(){
			const data = {
				selected_uf_value: this.selectedUfValue,
				project: this.project,
				colors: this.colors,
				colorVars: this.colorVars,
				ufValue: this.ufValue,
				currency: this.currency,
				colWidths: this.colWidths,
				canShowReceptionSection: this.canShowReceptionSection,
				cost_categories_config: this.cost_categories_config,
				project_tables: this.costs_table.project_tables
			}
			this.$store.commit('costbreakdown/setModalProjectTables', data)
			this.$store.commit('costbreakdown/setShowModalProjectTables', true)
		},
		scrollToBottom() {
			window.scrollTo({
				top: document.documentElement.scrollHeight,
				behavior: 'smooth'
			})
		},
		async createTableCostAddendum(){
			if(this.hasAddendumWithCostTable){
				// this.$router.push({ name: 'ProjectCostBreakdown', params: { id: this.project.id }, query: { contract: this.openAddendum.id } })
				this.tab = 1
				// this.scrollToBottom()
			}
			else if(this.hasAddendumWithoutCostTable){
				// Encontrar el anexo sin tabla de costo
				const addendum = this.contract.addendums?.find(addendum => addendum.last_status?.status < this.contractStatuses.FIRMADO_CONTRAPARTE)
				if(addendum){
					// Crear tabla de costo para el anexo existente
					await getProjectCostDetail({project_id: this.project.id, contract_id: addendum.id})
					this.loading = true
					this.getCosts()
					this.tab = 1
					const messageData = {
						message: 'Se ha creado la tabla de costo para el anexo existente.',
						title: 'Tabla de Costo Creada',
						type: 'success',
						icon: 'mdi-check-circle',
						color: '#3EBFA3',
					}
					this.setMessage(messageData)
				}
			}
			else{
				const data = {
					contract_id: this.contract.id
				}
				const addendum = await addContractAddendum(data)
				if(addendum.code == 200){
					if(addendum.addendum_notsigned){
						const messageData = {
							message: 'Ya existe un anexo abierto para este proyecto.',
							title: 'Anexos sin finalizar',
							type: 'danger',
							icon: 'mdi-close-octagon',
							color: '#FF1209',
						}
						this.setMessage(messageData)
						return null
					}

					await getProjectCostDetail({project_id: this.project.id, contract_id: addendum.contract_addendum.id})

					this.loading = true
					this.getCosts()
					this.tab = 1
					// this.$router.push({ name: 'ProjectCostBreakdown', params: { id: this.project.id }, query: { contract: addendum.contract_addendum.id } })
					const messageData = {
						message: 'Se ha creado correctamente el anexo.',
						title: 'Anexo Creado',
						type: 'success',
						icon: 'mdi-check-circle',
						color: '#3EBFA3',
					}
					this.setMessage(messageData)
				}
				else{
					const messageData = {
						message: 'Hubo un error en la operación, por favor intenta nuevamente',
						title: 'Ha ocurrido un error',
						type: 'danger',
						icon: 'mdi-close-octagon',
						color: '#FF1209',
					}
					this.setMessage(messageData)
				}
			}
		},
		editProjectPlanning(){
			this.$store.commit('projects/setProjectPlanningConfigModal', {project: this.project, status: true})
		},
    editUser() {
			const data = {
				...this.project?.client,
				...{
					user_id: this.project?.client?.id,
					contract_id: this.contract.id,
					client: true
				}
			}
			this.$store.commit('users/setNewUserModalEditing', data)
			this.$store.commit('users/setNewUserModal', true)
    },
		editProjectData(){
			const data =  {
				...this.project,
				...{
					parent_type: 'contract',
					parent_id: this.contract.id,
				}
			}
			this.$store.commit('projects/setEditProjectModal', data)
		},
		async changeContractPrefix(contract_prefix_id){
			await updateContract({contract_id: this.contract.id, contract_prefix_id})
			this.getCosts()
			this.prefixMenu = false
		},
		async changeIptZone(zone_id){
			const data = {
				project_id: this.project?.id,
				zone_id
			}
			const project_info = await updateProjectInfo(data)
			if(project_info.code == 200){
				this.getCosts()
			}
		},
		getType(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'crm'
				case "App\\Models\\PreProject":
					return 'preproject'
				case "App\\Models\\Project":
					return 'project'
				default:
					break;
			}
			return 'Otro'
		},
		async changeResponsible(responsible_id){
			const item_type = this.getType(this.contract.morphable_type)
			if(item_type == 'crm'){
				// await assignScheduleToUser({schedule_id: this.contract.morphable.schedule.user_schedule.id, new_user_id: responsible_id})
				await editCrmResponsible({conversation_id: this.contract.morphable_id, responsible_id})
			}
			else if(item_type == 'preproject'){
				await setResponsiblePreProject({preproject_id: this.contract.morphable_id, responsible_id})
			}
			else if(item_type == 'project'){
				await setResponsibleProject({project_id: this.contract.morphable_id, responsible_id, from_state: 'cost_table'})
			}
			this.getCosts()
			// this.getParentInfo()
			this.responsibleMenu = false
		},
		handleGoTo(association){
			if(association.morphable_type == 'App\\Models\\PreProject'){
				this.$store.commit('preprojects/setPreProjectModalId', association.morphable_id)
			}
			else if(association.morphable_type == 'App\\Models\\BotConversation'){
				this.$store.commit('crm/setCrmModalId', association.morphable_id)
			}
		},
		async changeProjectType(project_type_id){
			this.projectTypeMenu = false
			const data = {
				contract_id: this.contract.id,
				project_type_id
			}
			const project = await updateContract(data)
			if(project.code == 200){
				// this.project = {
				// 	...this.project,
				// 	...project.project_update_info,
				// 	info: {
				// 		...this.project.info,
				// 		...project.project_update_info.info
				// 	}
				// }
				if(project.project_update_info?.info?.project_type?.type != 2){
					this.removeReception()
				}
				this.debounceGetCosts()
			}
		},
		async changeProjectDestiny(project_destiny_id){
			this.projectTypeMenu = false
			const data = {
				project_id: this.project.id,
				destiny_id: project_destiny_id
			}
			const project = await updateProjectInfo(data)
			if(project.code == 200){
				this.project = {
					...this.project,
					...project.project_update_info,
					info: {
						...this.project.info,
						...project.project_update_info.info
					}
				}
				if(this.project?.info?.project_type?.type != 2){
					this.removeReception()
				}
			}
		},
		handleCostPaymentChange(){
			this.costs_table = {
				...this.costs_table
				// ...{payments: newValue}
			}
		},
		handleStageTitleChange(update) {
			const payment = this.costs_table.payments.find(
				p => p.id === update.payment_id
			)
			if (!payment) return
			this.$set(payment, 'subcontract_stage_title', update.title)
		},
		handleSubcontractInfoChange(updatedTables){
			// console.log('[DEBUG] handleSubcontractInfoChange', updatedTables)
			Object.entries(updatedTables).forEach(([projectTableId, tableData]) => {
				// Si es la tabla principal (costsTable)
				if (this.costs_table.id === parseInt(projectTableId)) {
					// Usar spread operator para asegurar reactividad
					this.costs_table = {
						...this.costs_table,
						annulated_subcontracts_info: tableData.annulated_subcontracts_info,
						subcontracts_info: tableData.subcontracts_info
					}
				} else {
					// Si es una tabla secundaria (project_tables/anexos)
					const projectTableIndex = this.costs_table.project_tables.findIndex(pt => pt.id === parseInt(projectTableId))
					if (projectTableIndex !== -1) {
						const updatedProjectTable = {
							...this.costs_table.project_tables[projectTableIndex],
							annulated_subcontracts_info: tableData.annulated_subcontracts_info,
							subcontracts_info: tableData.subcontracts_info
						}
						this.$set(this.costs_table.project_tables, projectTableIndex, updatedProjectTable)
					}
				}
			})
			// Guardar cambios
			// this.startSaveCostTable(true)
		},
		updateCostPaymentConfig(payment_config){
			this.cost_table.payments = payment_config
		},
		onChangeReceptionValue(){
			if(this.costs_table.reception){
				this.removeReception()
			}
			else{
				this.addReception()
			}
		},
		updateStage(val, index){
			val ? this.costs_table.stages.splice(index, 1, val):this.costs_table.stages.splice(index, 1)
		},
		updateSurfaceItems(items) {
			if(!items){
				this.costs_table.surfaces = null
				return;
			}
			if (!this.costs_table.surfaces) {
				this.costs_table.surfaces = {}
			}
			this.costs_table.surfaces.items = items
		},
		updateCostItems(items) {
			if(!items){
				this.costs_table.items = []
				return;
			}
			this.costs_table.items = items
		},
		removeReception(){
			this.costs_table.reception = null
		},
		updateReception(items){
			if(!items || items.length == 0){
				this.costs_table.reception = null
				return;
			}
			if (!this.costs_table.reception) {
				this.costs_table.reception = {}
			}
			this.costs_table.reception.items = items
		},
		onAddReceptionToProjectCost(){
			this.tab = 0
			this.addReception(true)
			this.$nextTick(() => {
				setTimeout(() => {
					this.$refs.receptionSection && this.$refs.receptionSection.scrollIntoView({ behavior: 'smooth' })
				}, 300)
			})
		},
		toContractDetail(){
			const contract = this.contract
			if(!contract || !contract.id) return;
			if(contract.addendum_to_contract_id){
				this.$router.push({ name: 'ContractAddendumDetail', query: { id: contract.id } })
				return null
			}
			localStorage.setItem('last_working_contract', JSON.stringify(contract))
			this.$router.push({ name: 'ContractDetail', query: { id: contract.id } })
		},
		onChangeTaxSelection(tax){
			// this.costs_table = {...this.costs_table, ...{company_tax_id: tax.id, tax: tax.tax}}

			const workingId = this.working_cost_table?.id
			if (!workingId) return

			if (this.costs_table.id === workingId) {
				this.$set(this.costs_table, 'company_tax_id', tax.id)
				this.$set(this.costs_table, 'tax', tax.tax)
				return
			}

			const table = this.costs_table.project_tables?.find(
				t => t.id === workingId
			)

			if (table) {
				this.$set(table, 'company_tax_id', tax.id)
				this.$set(table, 'tax', tax.tax)
			}
		},
		calcFontColor(backgroundColor){
			if (!backgroundColor) return '#000';
			let hex = backgroundColor.replace('#', '');
			if (hex.length === 3) {
				hex = hex.split('').map(char => char + char).join('');
			}
			const r = parseInt(hex.substring(0, 2), 16);
			const g = parseInt(hex.substring(2, 4), 16);
			const b = parseInt(hex.substring(4, 6), 16);
			const brightness = (r * 299 + g * 587 + b * 114) / 1000;
			return brightness > 128 ? '#000' : '#fff';
		},
    openColorPicker(key) {
      this.activeColorKey = key
      this.colorPickerVisible = true
    },
		onChangeGeneralCostProject(project){
			this.costs_table = {
				...this.costs_table,
				cost_project_id: project.id,
				cost_project: project,
				...(project.is_architectural === false && {
					stages: [],
					reception: null,
					specialties: []
				})
			}
			// this.startSaveCostTable()
		},
		onChangeSecondaryCostProject(project, index){
			let newProject = this.costs_table.projects[index]
			newProject = {
				...newProject,
				...{
					project_id: project.id,
					project
				}
			}
			this.costs_table.projects.splice(index, 1, newProject)
			// this.startSaveCostTable()
		},
		onChangeSecondaryCostProjectItem(items, index){
			let newProject = this.costs_table.projects[index]
			newProject = {
				...newProject,
				...{
					items
				}
			}
			this.costs_table.projects.splice(index, 1, newProject)
			// this.startSaveCostTable()
		},
		costProjectDetailTotalCostSummary(index){
			const project = this.costs_table.projects[index]
			const totals = {
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0,
				total_cost_uf: 0,
				total_cost_clp: 0
			};

			const parse = (n) => parseFloat(n) || 0;

			if (Array.isArray(project.items)) {
				for (const item of project.items) {
					if (Array.isArray(item.subitems) && item.subitems.length) {
						for (const sub of item.subitems) {
							const qty = parse(sub.qty);
							const uf = parse(sub.unit_cost_uf);
							const clp = parse(sub.unit_cost_clp);

							totals.qty += qty;
							totals.unit_cost_uf += uf;
							totals.unit_cost_clp += clp;
							totals.total_cost_uf += uf * qty;
							totals.total_cost_clp += clp * qty;
						}
					} else {
						const qty = parse(item.qty);
						const uf = parse(item.unit_cost_uf);
						const clp = parse(item.unit_cost_clp);

						totals.qty += qty;
						totals.unit_cost_uf += uf;
						totals.unit_cost_clp += clp;
						totals.total_cost_uf += uf * qty;
						totals.total_cost_clp += clp * qty;
					}
				}
			}

			return totals;
		},
		getAssociationType(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'CRM / Visita Técnica'
				case "App\\Models\\PreProject":
					return 'PreProyecto'
				case "App\\Models\\Project":
					return 'Proyecto'
				default:
					return 'Otro'
			}
		},
		addStage(){
			const newItem = {
				id: null,
				company_stage_id: null,
				stage: null,
				active: false,
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0
			}
			const updatedProjectStage = [...this.costs_table.stages]
			updatedProjectStage.push(newItem)
			this.costs_table = {
				...this.costs_table,
				...{stages: updatedProjectStage}
			}
			// this.startSaveCostTable(true)
		},
		addSpecialty(){
			const newItem = {
				id: null,
				company_specialty_id: null,
				specialty: null,
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0
			}
			const updatedProjectSpecialties = [...this.costs_table.specialties]
			updatedProjectSpecialties.push(newItem)
			this.costs_table = {
				...this.costs_table,
				...{specialties: updatedProjectSpecialties}
			}
			// this.startSaveCostTable(true)
		},
		addReception(forced_reception = false){
			const newItem = {
				id: null,
				name: 'Recepción Final',
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0,
				items: []
			}
			this.costs_table = {
				...this.costs_table,
				reception: newItem,
				...(forced_reception && { with_reception: true })
			}
			// this.startSaveCostTable(true)
		},
		addProject(){
			const newItem = {
				id: null,
				project_id: null,
				project: null,
				items: []
			}
			const updatedProjects = [...this.costs_table.projects]
			updatedProjects.push(newItem)
			this.costs_table = {
				...this.costs_table,
				...{projects: updatedProjects}
			}
			// this.startSaveCostTable(true)
		},
		reloadCostTable(){
			this.costs_table = null
			setTimeout(() => {
				this.getCosts()
			}, 300)
		},
		cancelPendingSaves() {
			if (this.firstDelayTimerInternal) {
				clearTimeout(this.firstDelayTimerInternal)
				this.firstDelayTimerInternal = null
			}
			this.pendingCostsTableInternal = null
			this.accumulatedGetCostUpdated = false
		},
		onReloadInformation(info = null) {
			this.cancelPendingSaves()
			this.debounceGetCosts(info)
		},
		debounceGetCosts: _debounce(function(info = null) { this.getCosts(info) }, 300),
		async getCosts(info = null){
			this.isReloading = true
			const project_id = this.$route.params.id
			const contract_id = this.$route.query.contract
			const costs = await getProjectCostDetail({project_id, contract_id})
			if(costs.code == 200){
				this.project = null
				this.project = costs.project
				this.contract = costs.contract
				this.cost_categories_config = costs.cost_categories_config
				this.costs_table = {...JSON.parse(JSON.stringify(costs.project_cost)), control_date: + new Date()}
				this.costs_table_check = JSON.parse(JSON.stringify(this.costs_table))
				this.setUfSelectedValue()
				this.getUfValues()
				if(info?.from == 'addendum-creation-cost-table'){
					this.$nextTick(() => {
						setTimeout(() => {
							this.tab = 1
						}, 300)
					})
				}
			}
			this.loading = false
			this.isReloading = false
		},
		getUfValues(){
			this.$store.dispatch('general/getPosteriorDaysUf', {include_ids: [this.costs_table.uf_value_id]})
		},
		setUfSelectedValue(){
			if(this.working_cost_table){
				this.selectedUfValue = this.working_cost_table.uf_value
			}
		},
		updateColors(colorData) {
			this.$store.commit('costbreakdown/setCostTableColorMap', colorData);
		},
		removeProject(projectIndex) {
			if (this.costs_table.projects && this.costs_table.projects[projectIndex]) {
				this.costs_table.projects.splice(projectIndex, 1);
				// this.startSaveCostTable();
			}
		},
		updateReceptionItems(val) {
			if (!this.costs_table.reception) {
				this.costs_table.reception = {
					id: Date.now(),
					items: []
				};
			}
			this.costs_table.reception.items = val;
			// this.startSaveCostTable();
		},
		updateSpecialty(val, index) {
			if (!val) {
				this.costs_table.specialties.splice(index, 1);
			} else {
				this.costs_table.specialties.splice(index, 1, val);
			}
			// this.startSaveCostTable();
		},
		startSaveCostTable(get_cost_table_updated = false) {
			const run = async (arg) => {
				this.savingCostsTableInternal = true
				this.accumulatedGetCostUpdated = false

				try {
					await this.saveCostsTable(arg)
				} finally {
					this.savingCostsTableInternal = false

					if (this.pendingCostsTableInternal !== null) {
						const nextArg = this.pendingCostsTableInternal
						this.pendingCostsTableInternal = null
						run(nextArg)
					}
				}
			}
			if (!this.savingCostsTableInternal && !this.firstDelayTimerInternal) {
				this.accumulatedGetCostUpdated = get_cost_table_updated

				this.firstDelayTimerInternal = setTimeout(() => {
					this.firstDelayTimerInternal = null
					run(this.accumulatedGetCostUpdated)
				}, 300)
				return
			}
			if (this.firstDelayTimerInternal) {
				this.accumulatedGetCostUpdated =
					this.accumulatedGetCostUpdated || get_cost_table_updated

				clearTimeout(this.firstDelayTimerInternal)

				this.firstDelayTimerInternal = setTimeout(() => {
					this.firstDelayTimerInternal = null
					run(this.accumulatedGetCostUpdated)
				}, 300)

				return
			}
			if (this.pendingCostsTableInternal !== null) {
				this.pendingCostsTableInternal = this.pendingCostsTableInternal || get_cost_table_updated
			} else {
				this.pendingCostsTableInternal = get_cost_table_updated
			}
		},
		async saveCostsTable(get_cost_table_updated = true){
			// if(this.costs_table.id !== 112361){
			// 	console.log('[DEBUG] saveCostsTable called with costs_table:', this.costs_table)
			// 	return
			// }
			const data = {
				...this.costs_table,
				project_cost_id: this.costs_table.id,
				parent_project_cost_id: this.costs_table.id,
				get_cost_table_updated
			}
			
			const save_costs = await saveProjectCostDetail(data)
			if(save_costs.code == 200){
				if(save_costs.project_cost){
					const savedTable = JSON.parse(JSON.stringify(save_costs.project_cost))
					this.costs_table_check = JSON.parse(JSON.stringify(savedTable))
					this.costs_table = savedTable
				}
				const messageData = {
					message: 'Tabla de Costo guardada correctamente',
					title: 'Tabla de Costo Guardada',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.startSetMessage(messageData)
			}
			else{
				const messageData = {
					message: 'Hubo un error en la operación, por favor intenta nuevamente',
					title: 'Ha ocurrido un error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
		totalUf(category){
			if(category.items && category.items.length > 0){
				const totalUF = category.items.reduce((sum, cat) => {
					const items = category.specialty && cat.specialties ? cat.specialties : cat.items
					return sum + items.reduce((subSum, item) => subSum + (item.total_uf || 0), 0);
				}, 0).toFixed(2)
				return totalUF
			}
			return 0
		},
		totalClp(category){
			if(category.items && category.items.length > 0){
				const totalUF = category.items.reduce((sum, cat) => {
					const items = category.specialty && cat.specialties ? cat.specialties : cat.items
					return sum + items.reduce((subSum, item) => subSum + (item.total_clp || 0), 0);
				}, 0).toFixed(2)
				return totalUF
			}
			return 0
		},
		onChangeTemplate(template){
			this.cost_categories = template.detail
		},
		async removeCostTemplate(company_cost_template_id){
			await deleteCostTemplate({company_cost_template_id})
			this.$store.dispatch('costbreakdown/getCompanyCostTemplates')
		},
		async saveAsTemplate(){
			const detail = this.cost_categories.map((category,index1) => {
				return {
					order: index1 + 1,
					company_cost_category_id: category.company_cost_category_id,
					items: category.items.map((subcategory, index2) => {
						let subItems = category.specialty ? subcategory.specialties : subcategory.items
						return {
							order: index2 + 1,
							company_cost_subcategory_id: subcategory.company_cost_subcategory_id,
							items: subItems.map((item, index3) => {
								return {
									order: index3 + 1,
									company_cost_item_id: item.company_cost_item_id
								}
							})
						}
					})
				}
			})
			
			await createCostTemplate({
				name: this.templateName,
				detail
			})
		},
		changeVisualization(item_id, action = 1) {
			if (action == 1) {
				if (!this.showDetail.includes(item_id)) {
					this.showDetail.push(item_id);
				}
			} else {
				this.showDetail = this.showDetail.filter(id => id !== item_id);
			}
		},
		startSetMessage: _throttle(function(messageData) { this.setMessage(messageData) }, 5000),
		setMessage(messageData){
			const data = {
				message: messageData.message,
				title: messageData.title,
				created: new Date(),
				type: messageData.type,
				icon: messageData.icon,
				color: messageData.color,
			}
			this.$store.dispatch('general/addMessage', data)
		},
	},
};
</script>

<style scoped>
	.costbreakdown-detail-table{
		table-layout: fixed;
		width: 100%;
	}
	tr.no-hover-cells,
	tr.no-hover-cells td {
		background-color: inherit !important;
	}
	.action-container{
		width: 60px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	.custom-table-cost table .main-row{
		border-top: 2px solid #bcbcbc;
		border-bottom: 2px solid #bcbcbc;
	}
	.custom-table-cost table .header-rows-custom{
		/* background: rgb(120, 120, 120); */
		color: white;
		font-size: 10px;
		font-weight: bold;
	}
	.custom-table-cost table tbody tr.header-rows-custom td,
	.custom-table-cost table thead tr.header-rows-custom td{
		height: 25px;
	}
	.custom-table-cost table .header-rows-custom:hover{
		/* background: rgb(103, 103, 103) !important; */
	}

	.custom-color-tabs .v-tab{
		font-size: 12px;
	}
	.custom-color-tabs .v-tab.v-tab--active {
		background-color: #FF120B;
		color: #FFFFFF;
	}
	.custom-color-tabs .v-tab:not(.v-tab--active) {
		background-color: white;
		color: #000000!important;
	}
	/deep/.costbreakdown-detail-table,
	/deep/.costbreakdown-detail-table td{
		vertical-align: top;
	}
	/deep/.costbreakdown-detail-table:hover {
		background-color: rgb(235, 235, 235);
	}
	.custom-table-cost table {
		border-collapse: collapse;
	}
	.custom-table-cost table td,
	.custom-table-cost table th{
		border: 1px solid #ccc;
	}
	.blocked-content-cost-table {
		pointer-events: none;
		opacity: 0.6;
	}
</style>